module.exports = __webpack_public_path__ + "static/media/instagram.2266b706.svg";